module.exports = {
  localeName: 'fr-CH',
  momentFormat: 'DD.MM.YYYY'
};
